import { Component } from '@angular/core';
import { Router} from '@angular/router';
import { AuthService } from '../../core/auth.service';
import { StateService } from '../../core/state.service';

@Component({
  selector: 'nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.sass']
})
export class NavBarComponent {

    public screenMode = '';
    public user_option_toggle = true;

    constructor( public auth: AuthService, public router: Router, private state: StateService) {
        this.state.screen.subscribe( mode => this.screenMode = mode );
    }

    signOut(){
        this.user_option_toggle = true;
        this.auth.signOut();
    }

    goToMyAccount(){
        this.router.navigate(['my_account']);
        this.user_option_toggle = true;
    }

    goToMyDashboard(){
        this.router.navigate(['checkit-dashboard']);
        this.user_option_toggle = true;
    }
}

@Component({
    selector: 'footer-bar',
    template: `
<section class="more">
    <div>{{state.footer.show_banner == 'subscribe' ? ('You have ' + til_end + ' days left in your free trial.') : 'Running more events?'}} 
        <a routerLink="/my_account/manage_subscription">Upgrade your subsciption today.</a></div>
</section>
<footer>
    <div class="content">
        <div class="logo">
            <a routerLink="/"><img src="assets/logo@2x.png" alt="Checkit" width="120"></a>
        </div>
        <div class="spacer" style="flex:1"></div>
        <div class="links">
            <span class="row1"><a href="https://www.checkit.events/pricing/">Pricing</a>&nbsp;&middot;&nbsp;
                <a href="https://www.checkit.events/faq/">FAQ</a>&nbsp;&middot;&nbsp;
                <a href="https://www.checkit.events/support/">Support</a></span>
            <span>&copy; Copyright {{this_year}}&nbsp;&middot;&nbsp;
            <a href="https://www.checkit.events/support/">Privacy Policy</a>&nbsp;&middot;&nbsp;
                <a href="https://www.checkit.events/terms/">Terms of Use</a></span>
        </div>
    </div>
</footer>
    `,
    styles: [`
        footer { background: #333; font-family: Ubuntu; font-size: 14px; }
        .content { display: flex; align-items: center; width: 1240px; margin: 0 auto; height: 100px; }
        .content span { margin-left: 20px; }
        .content span, .content span a { color: #999;  }
        .content a { color: #fff; font-family: Ubuntu; font-size:14px; }
        .links {color:#FFF;}
        section.more { background: #fff; font-family: Ubuntu; font-size: 24px; 	min-height: 100px; display: flex; 
            justify-content: center; align-items: center; text-align: center; padding: 0 20px; font-weight: 100; color:#333;  }
        section.more a {color: #2255FF; font-family: Ubuntu; font-size:24px; font-weight: normal; }
        @media screen and (max-width: 1280px) {
            .content { width: 100%; padding: 0 20px; }
        }
        @media screen and (max-width: 767px) {
            .content { flex-direction: column; height: 140px; justify-content:center; }
            .content span { margin-left: 0; text-align: center; }
            .content .spacer { display: none; }
            .content .links { display: flex; flex-direction: column; align-items: center; }
            .content .links .row1 { padding:15px 0 10px; }
            .content .links .row1 a { color:#fff; }
        }
    `]
})
export class FooterBarComponent {
    til_end = 0;
    get this_year() {
        const d = new Date();
        return d.getFullYear();
    }
    constructor(public state: StateService){
        this.state.$requests.subscribe(request => {
            if(request.request == 'subscriptionStatusSet') {
                if (this.state.subscription_object.days_til_end > 0 ) {
                    this.til_end = this.state.subscription_object.days_til_end;
                }
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/nav-bar/nav-bar.component.ts